import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import GlassCard from '../components/GlassCard';
import UserManagement from '../components/admin/UserManagement';
import MembersManagement from '../components/admin/MembersManagement';
import RelationManagement from '../components/admin/RelationManagement';

const AdminPage = () => {
  const { theme } = useTheme();
  const [activeTab, setActiveTab] = useState('users'); // 'users', 'members', 'relations'

  const tabs = [
    { id: 'users', label: 'User Management', icon: '👤' },
    { id: 'members', label: 'Members Management', icon: '👥' },
    { id: 'relations', label: 'Relation Management', icon: '🔗' },
  ];

  return (
    <div style={{ padding: '16px 0', width: '100%', maxWidth: '100%' }} className="admin-page">
      <GlassCard style={{ marginBottom: '24px', padding: 'clamp(16px, 4vw, 24px)' }}>
        <h1 style={{ fontSize: 'clamp(24px, 5vw, 32px)', margin: '0 0 24px 0', color: theme.text.primary }}>
          👑 Admin Console
        </h1>
        
        {/* Tab Navigation */}
        <div style={{
          display: 'flex',
          gap: '8px',
          borderBottom: theme.glass.border,
          marginBottom: '24px',
          flexWrap: 'wrap',
        }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '12px 20px',
                borderRadius: '8px 8px 0 0',
                border: 'none',
                borderBottom: activeTab === tab.id ? `3px solid ${theme.accent.primary}` : '3px solid transparent',
                background: activeTab === tab.id ? theme.card.background : 'transparent',
                color: activeTab === tab.id ? theme.accent.primary : theme.text.secondary,
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: activeTab === tab.id ? 600 : 500,
                transition: 'all 0.3s ease',
                minHeight: '44px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'users' && <UserManagement />}
          {activeTab === 'members' && <MembersManagement />}
          {activeTab === 'relations' && <RelationManagement />}
        </div>
      </GlassCard>
    </div>
  );
};

export default AdminPage;
